// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: 30,
    }
};

// Declare Templates
var bcSfFilterTemplate = {
    'soldOutClass': 'sold-out',
    'saleClass': 'sale',
    'soldOutLabelHtml': '<div>' + bcSfFilterConfig.label.sold_out + '</div>',
    'saleLabelHtml': '<div>' + bcSfFilterConfig.label.sale + '</div>',
    'vendorHtml': '<div>{{itemVendorLabel}}</div>',

    // Grid Template
  		'productGridItemHtml': '<div class="product-grid prel lazyload--placeholder {{hideCard}}" data-product-id="{{id}}">' +
                              '<div class="img-container">' +
                                  '<a href="{{itemUrl}}" onclick="track_click(event);" data-product-id="{{id}}" class="js-img-hover br-cl-cta" onmouseenter="window.hoverSecond($(this))" onmouseleave="window.hoverSecond($(this))">' +
  								  	'<div class="hover-img-container">' +
                                      '{{itemThumbUrl}}' +
                                      '<img class="hover-show" loading="lazy" src="{{itemThumbUrl2}}" alt="" style="display:none;">' +
                              		'</div>' +
                                  '</a>' +
  								  '<div class="quick-add-container">' +
  									  '<button class="js-quick-add quick-add-btn {{btnAvailabilityClass}}" data-color="{{currentColor}}" data-handle="{{prHandle}}" onclick="toggleQuickadd($(this))" data-pr-title="{{prTitle}}">' +
                                        '{{quickAddBtn}}' +
                                      '</button>' +
                                    '</div>' +
                              '</div>' +
                              '<div class="prod-details {{saleClass}}">' +
                                  '<div class="prod-title"><a href="{{itemUrl}}">{{itemTitle}}</a></div>' +
                                  '{{colorsNotice}} {{itemPrice}} {{promoNotice}} {{exclvNotice}} {{bundleNotice}} {{newNotice}} {{saleNotice}} {{customLabel}}' +
                              '</div>' +
                          '</div>',

    // Pagination Template
    'previousActiveHtml': '<li><a href="{{itemUrl}}">&larr;</a></li>',
    'previousDisabledHtml': '<li class="disabled"><span>&larr;</span></li>',
    'nextActiveHtml': '<li><a href="{{itemUrl}}">&rarr;</a></li>',
    'nextDisabledHtml': '<li class="disabled"><span>&rarr;</span></li>',
    'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
    'pageItemSelectedHtml': '<li><span class="active">{{itemTitle}}</span></li>',
    'pageItemRemainHtml': '<li><span>{{itemTitle}}</span></li>',
    'paginateHtml': '<ul class="pagination-custom">{{previous}}{{pageItems}}{{next}}</ul>',
  
    // Sorting Template
//     'sortingHtml': '<label class="label--hidden">' + bcSfFilterConfig.label.sorting + '</label><select class="collection-sort__input">{{sortingItems}}</select>',
    'sortingHtml': '<select class="collection-sort__input">{{sortingItems}}</select>',
};

/************************** BUILD PRODUCT LIST **************************/
var uData = [];
// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
  
    /*** Prepare data ***/
    var images = data.images_info;
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data.selected_or_first_available_variant;
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/
  
    var productTitle = ''


    if (data.title.indexOf(firstVariant.option1) >= 0) {
      productTitle = data.title.replace(firstVariant.option1, '');
    }else {
      productTitle = data.title;
    }

    if(!data.available) {
      return ''
    }else {
    	uData.push(productTitle)
    }
  
  

    //Percent Calculation by Rengie Nullan
    var diffVal = data.compare_at_price_min - data.price_min,
      	rawPercent = diffVal/data.compare_at_price_min,
        percentVal = rawPercent * 100,
        percentHtml = "";
//   	console.log(Math.round(percentVal))  

    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml


    // Add Thumbnail
    // var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src']) : bcSfFilterConfig.general.no_image_url;
    var itemThumbUrl = buildImageTemplate(data, 360, '')
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);
  
  	// 2nd Thumbnail
    var itemThumbUrl2 = images.length > 1 ? formatImageSize(images[1]['src'], '360x') : formatImageSize(images[0]['src'], '360x');
    itemHtml = itemHtml.replace(/{{itemThumbUrl2}}/g, itemThumbUrl2);

  
  
    var variantsOnSale = '';

    if(data.tags.includes('Sale')) {
      variantsOnSale = data.variants.filter(variant => variant.available && variant.compare_at_price > variant.price )
    }

    // Add Price
    var itemPriceHtml = '';
    if (data.title != '')  {
      
      
       itemPriceHtml += '';
        if (onSale && variantsOnSale.length > 0) {
//           if (priceVaries) {
          
          itemPriceHtml += '<span class="regular-price strike">' + this.formatMoney(data.compare_at_price_min) + '</span> ' + '<span class="sale-price"> Now ' + this.formatMoney(variantsOnSale[0].price) + '<span>';
//             itemPriceHtml +=  '<span class="regular-price">' + this.formatMoney(variantsOnSale[0].price) + '</span>';
//             itemPriceHtml += '<span class="sale-price">' + (bcSfFilterConfig.label.from_price).replace(/{{ price }}/g, this.formatMoney(variantsOnSale[0].compare_at_price)) + '</span>';
//           } 
//           else {
//             itemPriceHtml += '<span class="regular-price">' + this.formatMoney(data.compare_at_price_min) + '</span> ' + '<span class="sale-price"> Now ' + this.formatMoney(variantsOnSale[0].price) + '<span>';
// //             itemPriceHtml +=  '<span class="regular-price">' + this.formatMoney(data.price_min) + '<span>';
//           }
        } else {
//           if (priceVaries) {
//             itemPriceHtml += '<span class="regular-price">' + (bcSfFilterConfig.label.from_price).replace(/{{ price }}/g, this.formatMoney(firstAvailableVariant.price)) + '</span>';
//           } else {
            itemPriceHtml +=  '<span class="regular-price">' + this.formatMoney(data.price_min) + '</span>';
//           }
        }
        itemPriceHtml += '';
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add soldOut class
    var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
  
    // Add onSale class
    var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
    itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
  
    // Add soldOut Label
    var itemSoldOutLabelHtml = soldOut ? bcSfFilterTemplate.soldOutLabelHtml : '';
    itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabelHtml);

    // Add onSale Label
    var itemSaleLabelHtml = onSale ? bcSfFilterTemplate.saleLabelHtml : '';
    itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml);

    // Add Vendor
    var itemVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor) : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);
  
  
    // Add Additional Color Notice
    var colorNotice = '';
    var saleNotice = '';
    var promoNotice = ''; 
    var exclsvNotice = ''; 
    var bundleNotice = '';
    var newNotice = '';
  	var customLabel = '';
  
    var productVariants = data.options_with_values;
    var productcolors = '';
    var colorCtr = 0;
  	let dataTags = data.tags;
  	let textLabel = '';
  
    $.each(productVariants, function(i,e) {
      if (e.name == "color") {
        $.each(e.values, function(id,el) {
          colorCtr++;
        });
      }
    }); 
  

    for(var t = 0; dataTags.length > t; t++ ){
      if(dataTags[t].substring(0, 5) == 'Label'){
        textLabel = dataTags[t].substring(8, dataTags[t].length)
  
  		customLabel += `<p class="prod-notice">${textLabel}</p>`;
      }
    }
  
    if(colorCtr > 1){
        colorNotice = '<p class="prod-notice">see additional colors</p>';
    } else{
        colorNotice = ''; 
    }

    if(data.tags.indexOf('Online Exclusives') > -1){
        exclsvNotice = '<p class="prod-notice">online exclusive</p>'
    } else{
        exclsvNotice = ''
    }
  
//    if(data.tags.indexOf('Promo') > -1){
//        promoNotice = '<p class="prod-notice">limited time only</p>';
//    } else {
//        promoNotice = ''; 
//    }
  
    if(data.tags.indexOf('Bundles') > -1){
        bundleNotice = '<p class="prod-notice">buy more, save more</p>';
    } else {
        bundleNotice = ''; 
    } 
  

//     if(data.tags.indexOf('BR Holiday 19') > -1){
//         newNotice = '<p class="prod-notice">First look online, in-store 11/13</p>'
//     } else {
//         newNotice = ''; 
//     }
  
  
  
    if(onSale && variantsOnSale.length > 0){
        saleNotice = '<p class="prod-notice sale">Sale</p>';
    } else {
        saleNotice = ''; 
    }
  
  	var quickAddBtn = theme.quickAddIcon;
  
  	var firstColor = data.options_with_values.find(data => data.label == 'Color').values[0].title
    
  
  	itemHtml = itemHtml.replace(/{{hideCard}}/g, !data.available ? 'hide-oos' : '')
  	itemHtml = itemHtml.replace(/{{currentColor}}/g, firstColor)
  	itemHtml = itemHtml.replace(/{{prTitle}}/g, data.title.replace(/"/g, "'"))
    itemHtml = itemHtml.replace(/{{prHandle}}/g, data.handle);
  
  	itemHtml = itemHtml.replace(/{{btnAvailabilityClass}}/g, data.available ? 'ready-to-add' : 'out-of-stock')
  
  	itemHtml = itemHtml.replace(/{{quickAddBtn}}/g, quickAddBtn);
  	

    itemHtml = itemHtml.replace(/{{promoNotice}}/g, promoNotice);
    itemHtml = itemHtml.replace(/{{colorsNotice}}/g, colorNotice);
    itemHtml = itemHtml.replace(/{{exclvNotice}}/g, exclsvNotice);
    itemHtml = itemHtml.replace(/{{saleNotice}}/g, saleNotice); 
    itemHtml = itemHtml.replace(/{{bundleNotice}}/g, bundleNotice);
    itemHtml = itemHtml.replace(/{{newNotice}}/g, newNotice); 
    itemHtml = itemHtml.replace(/{{percentHtml}}/g, percentHtml);
    itemHtml = itemHtml.replace(/{{customLabel}}/g, customLabel);
  

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));
    itemHtml = itemHtml.replace(/{{id}}/g, data.id);
  
    return itemHtml;
  
 
  
};

// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function(data) {
    // // Add Description
    // var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
    // // Truncate by word
    // itemDescription = (itemDescription.split(" ")).length > 51 ? itemDescription.split(" ").splice(0, 51).join(" ") + '...' : itemDescription.split(" ").splice(0, 51).join(" ");
    // // Truncate by character
    // itemDescription = itemDescription.length > 350 ? itemDescription.substring(0, 350) + '...' : itemDescription.substring(0, 350);
    // itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);
};

/************************** END BUILD PRODUCT LIST **************************/

function buildImageTemplate(data, size, imgClass) {
  var size = size || null;
  var img = null;
  if(data.featured_image) {
    img = data.featured_image;
  }else {
    img = data.images_info[0];
  }
  var tpl = `<img 
              srcset="${size ? img.width >= 220 && img.width <= size ? `${formatImageSize(img.src, '220x')} 220w,` : '' : img.width >= 220 ? `${formatImageSize(img.src, '220x')} 220w,` : ''}
              ${size ? img.width >= 375 && img.width <= size ? `${formatImageSize(img.src, '375x')} 375w,` : '' : img.width >= 375 ? `${formatImageSize(img.src, '375x')} 375w,` : ''}
              ${size ? img.width >= 550 && img.width <= size ? `${formatImageSize(img.src, '550x')} 550w,` : '' : img.width >= 550 ? `${formatImageSize(img.src, '550x')} 550w,` : ''}
              ${size ? img.width >= 750 && img.width <= size ? `${formatImageSize(img.src, '750x')} 750w,` : '' : img.width >= 750 ? `${formatImageSize(img.src, '750x')} 750w,` : ''}
              ${size ? img.width >= 1100 && img.width <= size ? `${formatImageSize(img.src, '1100x')} 1100w,` : '' : img.width >= 1100 ? `${formatImageSize(img.src, '1100x')} 1100w,` : ''}
              ${size ? img.width >= 1500 && img.width <= size ? `${formatImageSize(img.src, '1500x')} 1500w,` : '' : img.width >= 1500 ? `${formatImageSize(img.src, '1500x')} 1500w,` : ''}
              ${size ? img.width >= 1780 && img.width <= size ? `${formatImageSize(img.src, '1780x')} 1780w,` : '' : img.width >= 1780 ? `${formatImageSize(img.src, '1780x')} 1780w,` : ''}
              ${size ? img.width >= 2000 && img.width <= size ? `${formatImageSize(img.src, '2000x')} 2000w,` : '' : img.width >= 2000 ? `${formatImageSize(img.src, '2000x')} 2000w,` : ''}
              ${size ? img.width >= 3000 && img.width <= size ? `${formatImageSize(img.src, '3000x')} 3000w,` : '' : img.width >= 3000 ? `${formatImageSize(img.src, '3000x')} 3000w,` : ''}
              ${size ? img.width >= 3840 && img.width <= size ? `${formatImageSize(img.src, '3840x')} 3840w,` : '' : img.width >= 3840 ? `${formatImageSize(img.src, '3840x')} 3840w,` : ''}
              ${size ? img.width >= 3840 && img.width <= size ? `${formatImageSize(img.src, img.width)}` : '' : img.width >= 3840 ? `${formatImageSize(img.src, img.width)}` : ''}
              "
              loading="lazy"
              src="${size ? formatImageSize(img.src, `${size}x`) : formatImageSize(img.src, img.width)}"
              alt="${img.alt ? img.alt : ''}"
              sizes="(min-width: 769px) 20vw, 40vw"
              width="${img.width}"
              height="${img.width / (img.width / img.height)}"
              class="${imgClass}">`;
    return tpl;
}

function formatImageSize(src, size) {
  // remove any current image size then add the new image size
  return src
    .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, '.')
    .replace(/\.jpg|\.png|\.gif|\.jpeg/g, function(match) {
      return '_'+size+match;
    })
  ;
}


// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    if (this.getSettingValue('general.paginationType') == 'default') {
        // Get page info
        var currentPage = parseInt(this.queryParams.page);
        var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

        // If it has only one page, clear Pagination
        if (totalPage == 1) {
            jQ(this.selector.bottomPagination).html('');
            return false;
        }

        if (this.getSettingValue('general.paginationType') == 'default') {
            var paginationHtml = bcSfFilterTemplate.paginateHtml;

            // Build Previous
            var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
            previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
            paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

            // Build Next
            var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml :  bcSfFilterTemplate.nextDisabledHtml;
            nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
            paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

            // Create page items array
            var beforeCurrentPageArr = [];
            for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
                beforeCurrentPageArr.unshift(iBefore);
            }
            if (currentPage - 4 > 0) {
                beforeCurrentPageArr.unshift('...');
            }
            if (currentPage - 4 >= 0) {
                beforeCurrentPageArr.unshift(1);
            }
            beforeCurrentPageArr.push(currentPage);

            var afterCurrentPageArr = [];
            for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
                afterCurrentPageArr.push(iAfter);
            }
            if (currentPage + 3 < totalPage) {
                afterCurrentPageArr.push('...');
            }
            if (currentPage + 3 <= totalPage) {
                afterCurrentPageArr.push(totalPage);
            }

            // Build page items
            var pageItemsHtml = '';
            var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
            for (var iPage = 0; iPage < pageArr.length; iPage++) {
                if (pageArr[iPage] == '...') {
                    pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
                } else {
                    pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
                }
                pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
                pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
            }
            paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

            jQ(this.selector.bottomPagination).html(paginationHtml);
        }
    }
};

/************************** BUILD TOOLBAR **************************/

let sort_count = 0;
// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function(e) {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');
        var sortingArr = this.getSortingList();
        if (sortingArr) {
            const selectDefault = (sort_count == 0) ? "sort" : (this.queryParams.sort == "created-ascending") ? "sort" : this.queryParams.sort
            
            // Build content 
            var sortingItemsHtml = '';
                sortingItemsHtml += '<option value="sort" selected disabled hidden>Sort By</option>';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
            }
//           	console.log(sortingItemsHtml)
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
//           	console.log(html)
            jQ(this.selector.topSorting).html(html);

//           	console.log(this.queryParams)
            // Set current value
          	// console.log(selectDefault)
            jQ(this.selector.topSorting + ' select').val(selectDefault);
			sort_count++
        }
    }
};


BCSfFilter.prototype.buildSortingEvent = function() {
    var self = this;
    jQ(this.getSelector('topSorting') + ' select').change(function(e) {
      // console.log(self.queryParams.sort)
      // console.log(jQ(this).val())
      onInteractWithToolbar(e, 'sort', self.queryParams.sort, jQ(this).val());
    })
};

// Build Display type (List / Grid / Collage)
// BCSfFilter.prototype.buildFilterDisplayType = function() {
//     var itemHtml = '<a href="' + this.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="change-view bc-sf-filter-display-grid" data-view="grid"><span class="icon-fallback-text"><i class="fa fa-th" aria-hidden="true"></i><span class="fallback-text">Grid view</span></span></a>';
//     itemHtml += '<a href="' + this.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="change-view bc-sf-filter-display-list" data-view="list"><span class="icon-fallback-text"><i class="fa fa-list" aria-hidden="true"></i><span class="fallback-text">List view</span></span></a>';
//     jQ(this.selector.topDisplayType).html(itemHtml);

//     // Active current display type
//     jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').removeClass('active');
//     jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').removeClass('active');
//     if (this.queryParams.display == 'list') {
//         jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').addClass('active');
//     } else if (this.queryParams.display == 'grid') {
//         jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').addClass('active');
//     }
// };

/************************** END BUILD TOOLBAR **************************/

// Build Default layout
function buildDefaultLink(a,b){var c=window.location.href.split("?")[0];return c+="?"+a+"="+b}BCSfFilter.prototype.buildDefaultElements=function(a){if(bcSfFilterConfig.general.hasOwnProperty("collection_count")&&jQ("#bc-sf-filter-bottom-pagination").length>0){var b=bcSfFilterConfig.general.collection_count,c=parseInt(this.queryParams.page),d=Math.ceil(b/this.queryParams.limit);if(1==d)return jQ(this.selector.pagination).html(""),!1;if("default"==this.getSettingValue("general.paginationType")){var e=bcSfFilterTemplate.paginateHtml,f="";f=c>1?bcSfFilterTemplate.hasOwnProperty("previousActiveHtml")?bcSfFilterTemplate.previousActiveHtml:bcSfFilterTemplate.previousHtml:bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml")?bcSfFilterTemplate.previousDisabledHtml:"",f=f.replace(/{{itemUrl}}/g,buildDefaultLink("page",c-1)),e=e.replace(/{{previous}}/g,f);var g="";g=c<d?bcSfFilterTemplate.hasOwnProperty("nextActiveHtml")?bcSfFilterTemplate.nextActiveHtml:bcSfFilterTemplate.nextHtml:bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml")?bcSfFilterTemplate.nextDisabledHtml:"",g=g.replace(/{{itemUrl}}/g,buildDefaultLink("page",c+1)),e=e.replace(/{{next}}/g,g);for(var h=[],i=c-1;i>c-3&&i>0;i--)h.unshift(i);c-4>0&&h.unshift("..."),c-4>=0&&h.unshift(1),h.push(c);for(var j=[],k=c+1;k<c+3&&k<=d;k++)j.push(k);c+3<d&&j.push("..."),c+3<=d&&j.push(d);for(var l="",m=h.concat(j),n=0;n<m.length;n++)"..."==m[n]?l+=bcSfFilterTemplate.pageItemRemainHtml:l+=m[n]==c?bcSfFilterTemplate.pageItemSelectedHtml:bcSfFilterTemplate.pageItemHtml,l=l.replace(/{{itemTitle}}/g,m[n]),l=l.replace(/{{itemUrl}}/g,buildDefaultLink("page",m[n]));e=e.replace(/{{pageItems}}/g,l),jQ(this.selector.pagination).html(e)}}if(bcSfFilterTemplate.hasOwnProperty("sortingHtml")&&jQ(this.selector.topSorting).length>0){jQ(this.selector.topSorting).html("");var o=this.getSortingList();if(o){var p="";for(var q in o)p+='<option value="'+q+'">'+o[q]+"</option>";var r=bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g,p);jQ(this.selector.topSorting).html(r);var s=void 0!==this.queryParams.sort_by?this.queryParams.sort_by:this.defaultSorting;jQ(this.selector.topSorting+" select").val(s),jQ(this.selector.topSorting+" select").change(function(a){window.location.href=buildDefaultLink("sort_by",jQ(this).val())})}}};

// Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData=function(data){for(var k=0;k<data.length;k++){data[k]['product_type']=data[k]['product_type'];data[k]['images']=data[k]['images_info'];if(data[k]['images'].length>0){data[k]['featured_image']=data[k]['images'][0]}else{data[k]['featured_image']={src:bcSfFilterConfig.general.no_image_url,width:'',height:'',aspect_ratio:0}}data[k]['url']='/products/'+data[k].handle;var optionsArr=[];for(var i=0;i<data[k]['options_with_values'].length;i++){optionsArr.push(data[k]['options_with_values'][i]['name'])}data[k]['options']=optionsArr;data[k]['price_min']*=100,data[k]['price_max']*=100,data[k]['compare_at_price_min']*=100,data[k]['compare_at_price_max']*=100;data[k]['price']=data[k]['price_min'];data[k]['compare_at_price']=data[k]['compare_at_price_min'];data[k]['price_varies']=data[k]['price_min']!=data[k]['price_max'];var firstVariant=data[k]['variants'][0];if(getParam('variant')!==null&&getParam('variant')!=''){var paramVariant=data.variants.filter(function(e){return e.id==getParam('variant')});if(typeof paramVariant[0]!=='undefined')firstVariant=paramVariant[0]}else{for(var i=0;i<data[k]['variants'].length;i++){if(data[k]['variants'][i].available){firstVariant=data[k]['variants'][i];break}}}data[k]['selected_or_first_available_variant']=firstVariant;for(var i=0;i<data[k]['variants'].length;i++){var variantOptionArr=[];var count=1;var variant=data[k]['variants'][i];var variantOptions=variant['merged_options'];if(Array.isArray(variantOptions)){for(var j=0;j<variantOptions.length;j++){var temp=variantOptions[j].split(':');data[k]['variants'][i]['option'+(parseInt(j)+1)]=temp[1];data[k]['variants'][i]['option_'+temp[0]]=temp[1];variantOptionArr.push(temp[1])}data[k]['variants'][i]['options']=variantOptionArr}data[k]['variants'][i]['compare_at_price']=parseFloat(data[k]['variants'][i]['compare_at_price'])*100;data[k]['variants'][i]['price']=parseFloat(data[k]['variants'][i]['price'])*100}data[k]['description']=data[k]['content']=data[k]['body_html']}return data};

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {};

window.init = 1;

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
  var from = this.queryParams.page == 1 ? this.queryParams.page : (this.queryParams.page - 1) * this.queryParams.limit + 1;
  var to = from + data.products.length - 1;
  if (to > data.total_product) to = data.total_product;
//   jQ("#esViewingText").html('Showing 1 to ' + to + ' of ' + data.total_product);
  jQ('#sort-total-products').text(data.total_product);
  jQ('#sort-total-products2').text(data.total_product);
  jQ('#sort-total-products3').text(data.total_product);
  jQ('#bc-sf-filter-options-wrapper').append('<div id="close-for-filter"><span class="one-line"></span><span class="two-line"></span></div>')
  
  if(data.total_product < 1){
    jQ('#item-ss').text('item') 
  } else {
   jQ('#item-ss').text('items')  
  }
  if(typeof(track_product_impression) === 'function') {
    var products = data.products.filter(product => product.available);
    if(products.length > 0) {
      track_product_impression(products)
    }
  }
    
  
    function filterDivide(){
    
    function appendBcData(tops, outer, bottom, inseam, dress, access, boxer, path){
      var bcData = $('#bc-sf-filter-block-content-size ul li').clone();
      $('#bc-sf-filter-block-content-size ul li').remove();

      var topsSizes = tops,
          owSizes = outer,
          bottomsSizes = bottom,
          dressSizes = dress,
          accessories = access,
          inseamSizes = inseam,
          boxSizes = boxer;

      var aNTF = $('<ul></ul>'), //arrayOfTopsFilters
          aNOF = $('<ul></ul>'), //arrayOfBottomsFilters
          aNBF = $('<ul></ul>'), //arrayOfAccessoriesFilters
          aNAF = $('<ul></ul>'), //arrayOfBottomsInseamsFilters
          aNIF = $('<ul></ul>'), //arrayOfBottomsFilters
          aNDF = $('<ul></ul>'), //arrayOfDressFilters
          aNBxF = $('<ul></ul>'); //arrayOfDressFilters

      $.each(bcData, function(i,e){
        var a = $(e).clone();
        var $e = a;
        var $b = $(e);
        var $c = $(e).clone();
        var $a = $(e).clone();
        if(topsSizes.indexOf($(e).text()) > -1){ aNTF.append($a) }
        if(owSizes.indexOf($(e).text()) > -1){ aNOF.append($b) }
        if(bottomsSizes.indexOf($(e).text()) > -1){ aNBF.append($e) }
        if(dressSizes.indexOf($(e).text()) > -1) { aNDF.append($e) }
        if(accessories.indexOf($(e).text()) > -1){ aNAF.append($e) }
        if(inseamSizes.indexOf($(e).text()) > -1) { aNIF.append($e) }
        if(boxSizes.indexOf($(e).text()) > -1) { aNBxF.append($c) }
      });

      var Tops = $('<div><h2 class="group-label">Tops</h2></div>').append(aNTF);
      var Bottoms = $('<div><h2 class="group-label">Bottoms</h2></div>').append(aNBF);
      var Dresses = $('<div><h2 class="group-label">Dresses</h2></div>').append(aNDF);
      var Outerwear = $('<div><h2 class="group-label">Outerwear</h2></div>').append(aNOF);
      var Accessories = $('<div><h2 class="group-label">Accessories</h2></div>').append(aNAF);
      var BotInseams = $('<div><h2 class="group-label">Bottoms(Inseam)</h2></div>').append(aNIF);
      var Boxers = $('<div><h2 class="group-label">Boxers</h2></div>').append(aNBxF);
      var Blazers

      if(path == '/collections/women'){
        $('#bc-sf-filter-block-content-size ul').append(Tops).append(Dresses).append(Bottoms).append(BotInseams).append(Accessories);
      } else if(path == '/collections/men'){
        $('#bc-sf-filter-block-content-size ul').append(Tops).append(Bottoms).append(Accessories);
      }                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               
    }


    if(location.pathname == '/collections/women'){

      var wTops = ['XS', 'S', 'M', 'L', 'XL', '0', '2', '4', '6', '8', '10']
          wAccessories = ['XS', 'S', 'M', 'L', '6', '8', 'ONE SIZE']
          wBottoms = [ '0 REG', '2 REG', '4 REG', '6 REG', '8 REG', '10 REG', '12 REG', '14 REG']
          wInseam = ['0 SHORT', '2 SHORT', '4 SHORT', '6 SHORT', '8 SHORT', '10 SHORT', '12 SHORT', '14 SHORT', '25 SHORT', '26 SHORT', '27 SHORT', '28 SHORT', '29 SHORT', '30 SHORT', '31 SHORT'],
          wDresses = ['0', '2', '4', '6', '8', '10', '12', '0P', '2P', '4P', '6P', '10P', '12P'];

      appendBcData(wTops, '', wBottoms, wInseam, wDresses, wAccessories, '' ,location.pathname);

    } else if(location.pathname == '/collections/men'){

      var mTops = ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
          mBottom = ['30', '31', '32', '33', '34', '36', '38'],
          mAccessories = ['30', '32', '34', '36', '38'];

      appendBcData(mTops, '', mBottom, '', '', mAccessories, '' ,location.pathname);
    }
    
  }
  
  if(window.init){
    filterDivide()
    window.init = 0;
  }  
  
  
  
  if(window.init == 0){
    window.init = 1;
      // console.log(data);    
    var sizeItems = jQ('#bc-sf-filter-block-content-size').find('li');
    sizeItems.each(function(i,e){

    });
    
  }
  
  if(jQ('.bc-sf-filter-pc.bc-sf-filter-selection-wrapper').length){
    $('.collections-main .filter-section').addClass('filtering-mode');
  } else{
     $('.collections-main .filter-section').removeClass('filtering-mode');
  }
  
  
};

//! MADE BY RENGIE FOR THE MEN/WOMEN DIVISION - 03/31/2021 New Code, Dynamic
// if(jQ('#div_meta').data('switch')){
//   console.log('div_meta switch is enabled');
//   console.log('meta_headers:', jQ('#div_meta').data('headers'));
  
//   const meta_headers = jQ('#div_meta').data('headers')

//   let division_obj = meta_headers.reduce((obj, {name, tag}, i) => {
//     const divObj = {}

//     divObj.tags = tag
//     divObj.divisionArray = [`<div class="relative-container division--line"><span>${name}</span></div>`]

//     obj.push(divObj)

//     return obj
//   }, [])

//   BCSfFilter.prototype.buildProductListData = function(a, b) {

//     if(b != 'page'){
//       division_obj = meta_headers.reduce((obj, {name, tag}, i) => {
//         const divObj = {}
//         divObj.tags = tag
//         divObj.divisionArray = [`<div class="relative-container division--line"><span>${name}</span></div>`]
//         obj.push(divObj)
//         return obj
//       }, [])
//     }

//     let c = "",
//         FilteredDivision = a.reduce((arr,item) => {
//           division_obj.forEach((div) => {
//             if(item.tags.includes(div.tags)){
//               div.divisionArray = div.divisionArray.concat(item)
//               arr = arr.concat(div.divisionArray)
//             }
//           })
//           return arr
//         }, []),
//         mergedData = division_obj.reduce((arr, {divisionArray}) => {
//           if(divisionArray.length > 1){
//             arr = arr.concat(divisionArray)
//           }

//           return arr
//         }, [])

//     for (let e = 0; e < mergedData.length; e++) {
//       if(typeof mergedData[e] !== 'object'){
//         c += mergedData[e]
//       } else{
//         let f = this.buildProductGridItem(mergedData[e], e + 1, mergedData.length)
//         c += this.buildProductItemAdvanced(mergedData[e], f)
//       }
//     }

//     jQ(this.getSelector("products")).empty();
//     jQ(this.getSelector("products")).append(c);
//   }

// }


//       //activate apply on click
//       $('.bc-sf-filter-option-item.bc-sf-filter-option-label').click(function(e){
//          e.prevenDefault();
        
//           var $this = $(this),
//               $ulParent = $this.closest('ul'),
//               $buttonApply = $ulParent.siblings('.bc-sf-filter-select-button')

//               $.buttonApply.trigger('click')
//       })  

BCSfFilter.prototype.prepareFilterParams = function(params, eventType) {
    // Get collection id
    if (!this.queryParams.hasOwnProperty('collection_scope')) {
        if (!this.isSearchPage()) {
            params.collection_scope = parseInt(this.collectionId);
            if (eventType == 'history') {
                var historyData = History.getState().data;
                if (historyData.hasOwnProperty('param') && historyData.param.hasOwnProperty('collection_scope')) {
                    params.collection_scope = this.collectionId = parseInt(historyData.param.collection_scope);
                } else {
                    params.collection_scope = this.collectionId = parseInt(bcSfFilterConfig.general.collection_id);
                }
            }
        } else {
            params.collection_scope = 0;
        }
    } else {
        params.collection_scope = Array.isArray(this.queryParams.collection_scope) ? this.queryParams['collection_scope'][0] : this.queryParams['collection_scope'];
    }
    // Get product/variant available or not
    if (this.getSettingValue('general.availableAfterFiltering') == true) {
        params.product_available = this.checkExistFilterOptionParam() === true ? true : this.productAvailable;
        params.variant_available = this.checkExistFilterOptionParam() === true ? true : this.variantAvailable;
    } else {
        params.product_available = this.productAvailable;
        params.variant_available = this.variantAvailable;
    }
    // Get Tag value
    if (typeof this.collectionTags !== 'undefined' && this.collectionTags !== null) params.tag = this.collectionTags;
    // Display filter option items even they return no product
    if (this.getSettingValue('general.showOutOfStockOption')) params.zero_options = true;
    // Build Filter tree or not
    params.build_filter_tree = (typeof eventType !== 'undefined' && this.imutableFilterTree.indexOf(eventType) > -1) ? false : true; // Except events of elements in filter tree, all remaining events do not rebuild filter tree
    // Enable cache when request params doest not have filter option values, "page" param equal to 1 and "sort" param equal to default sorting
    params.check_cache = (this.checkExistFilterOptionParam() === false && params['page'] == 1 && params['sort'] == this.defaultSorting && params['limit'] == this.getSettingValue('general.limit') && !this.isSearchPage() && !this.isVendorPage()) ? true : false;
    // Turn on price mode
    if (this.getSettingValue('general.priceMode') != '') params['price_mode'] = this.getSettingValue('general.priceMode');
    // Tag mode
    if (this.getSettingValue('general.tagMode') != '') params['tag_mode'] = this.getSettingValue('general.tagMode');
    // Availability Sorting
    if (this.getSettingValue('general.sortingAvailableFirst')) params.sort_first = 'available';
    // Vendor page: Get Vendor param
    if (this.isVendorPage() && params.hasOwnProperty('q')) {
        var vendorParam = this.getSettingValue('general.vendorParam');
        // params[vendorParam] = [params['q'].replace(/\+/g, ' ')];
        params[vendorParam] = [params['q']];
        delete params['q'];
    }
  
    // params.sort = 'extra-sort1-ascending';
    
    return params;
};


// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
    var self = bcsffilter;
    var ext = typeof ext !== 'undefined' ? ext : 'png';
    var version = typeof version !== 'undefined' ? version : '1';
    var prIndex = self.fileUrl.lastIndexOf('?');
    if (prIndex > 0) {
        var filePath = self.fileUrl.substring(0, prIndex);
    } else {
        var filePath = self.fileUrl;
    }
    filePath += fileName + '.' + ext + '?v=' + version;
    return filePath;
}

/* start-boost-2.4.8 */
BCSfFilter.prototype.buildFilterOptionItem=function(html,iLabel,iValue,fOType,fOId,fOLabel,fODisplayType,fOSelectType,fOItemValue,fOData){var keepValuesStatic=fOData.hasOwnProperty("keepValuesStatic")?fOData.keepValuesStatic:false;if(fOType=="review_ratings"&&this.getSettingValue("general.ratingSelectionStyle")=="text"){var title=this.getReviewRatingsLabel(fOItemValue.from)}else{var title=this.customizeFilterOptionLabel(iLabel,fOData.prefix,fOType)}if(keepValuesStatic===true)var productNumber=null;else var productNumber=fOItemValue.hasOwnProperty("doc_count")?fOItemValue.doc_count:0;html=html.replace(/{{itemLabel}}/g,this.buildFilterOptionLabel(iLabel,productNumber,fOData));html=html.replace(/{{itemLink}}/g,this.buildFilterOptionLink(fOId,iValue,fOType,fODisplayType,fOSelectType,keepValuesStatic));html=html.replace(/{{itemValue}}/g,encodeURIParamValue(iValue));html=html.replace(/{{itemTitle}}/g,title);html=html.replace(/{{itemFunc}}/g,"onInteractWithFilterOptionValue(event, this, '"+fOType+"', '"+fODisplayType+"', '"+fOSelectType+"', '"+keepValuesStatic+"')");html=this.checkFilterOptionSelected(fOId,iValue,fOType,fODisplayType)?html.replace(/{{itemSelected}}/g,"selected"):html.replace(/{{itemSelected}}/g,"");var htmlElement=jQ(html);htmlElement.children().attr({"data-id":fOId,"data-value":encodeURIParamValue(iValue),"data-parent-label":fOLabel,"data-title":title,"data-count":productNumber});if(fOType!="collection"){htmlElement.children().attr("rel","nofollow")}if(fOType=="collection")htmlElement.children().attr("data-collection-scope",fOItemValue.key);return jQ(htmlElement)[0].outerHTML};
/* end-boost-2.4.8 */
/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
